module.exports = __webpack_public_path__ + "static/media/duraphat.0b205bca.png";